module.exports = "/images/yiddish.svg?e4443dde0f65fc0ac7ac98ff08101dab";